function setDelay(el, delayMs) {
  if (typeof delayMs === 'number' && Number.isFinite(delayMs) && delayMs > 0) {
    el.style.animationDelay = `${delayMs}ms`;
  }
}

export const vReveal = {
  mounted(el, binding) {
    if (typeof window === 'undefined' || !('IntersectionObserver' in window)) {
      el.classList.add('animate-slide-up');
      return;
    }

    const delayMs =
      typeof binding?.value === 'number' ? binding.value : binding?.value?.delayMs ?? 0;

    el.classList.add('opacity-0');
    setDelay(el, delayMs);

    const observer = new IntersectionObserver(
      (entries) => {
        if (!entries[0]?.isIntersecting) return;
        el.classList.remove('opacity-0');
        el.classList.add('animate-slide-up');
        observer.disconnect();
      },
      { root: null, rootMargin: '0px 0px -10% 0px', threshold: 0.15 }
    );

    observer.observe(el);
    el.__v_reveal_observer__ = observer;
  },
  beforeUnmount(el) {
    el.__v_reveal_observer__?.disconnect?.();
    delete el.__v_reveal_observer__;
  },
};

